import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type PortfolioUpdateResponse = ResponseType<null>;

function usePortfolioUpdateMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<PortfolioUpdateResponse>["response"],
    AxiosResponseAndError<PortfolioUpdateResponse>["error"],
    {value:string,id:string}
  >({
    mutationFn: (data) =>
      ApiRequest.put<PortfolioUpdateResponse>(
        `${requestURLs.project}/protfolio-update/${data.id}`,
        data
      ),
  });

  return mutation;
}
export default usePortfolioUpdateMutation;
